<script>
export default {
    props: {crumbs: Array}
}
</script>
<template>
    <div class="breadcrumbs">
        <div class="breadcrumbs__item">
            <Link href="/" class="breadcrumbs__link">
                <img src="/img/general/home.svg" alt="главная">
            </Link>
        </div>
        <template v-for="item in crumbs">
            <div class="breadcrumbs__item">
                <img src="/img/general/navigateright-grey.svg">
            </div>
            <div class="breadcrumbs__item">
                <Link :href="item.url" class="breadcrumbs__link">
                    <div class="breadcrumbs__name">{{ item.name }}</div>
                </Link>
            </div>
        </template>
    </div>
</template>

